import React from "react";
import { connect } from "react-redux";
import { updateMMPLUserDetails, getMMPLUsersDetails, getMMPLUsersList } from "../Actions/UserManagementAPI";
import { getSpecialAccessUserDetails } from "../Actions/SpecialAccessUserManagementAPI";
import { getShipnameList } from "../Actions/HelpersAPI";
import { Multiselect } from "multiselect-react-dropdown";
import swal from "sweetalert";
import axios from "axios";
import API from "../helpers/api";
import { toast } from "react-toastify";

let userkey = JSON.parse(localStorage.getItem("currentUser"));

let searchData = {
    Mail: '',
    IsAdmin: false,
    PageNumber: 1,
    PageSize: 5
};
class EditUser extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            UserInfo: {
                mmplId: 0,
                emailId: "",
                isAdmin: false,
                mmplShips: [],
                modifiedBy: "",
                isDeleted: false
            },
            ships: [],
            Users: []
        }
        this.handleInputChange = this.handleInputChange.bind(this);
        this.UpdateData = this.UpdateData.bind(this);
        this.handleCheckBoxChange = this.handleCheckBoxChange.bind(this);
        this.onSelectChange = this.onSelectChange.bind(this);
        this.onRemoveChange = this.onRemoveChange.bind(this);
    }

    componentDidMount() {
        const { dispatch, match } = this.props;
        const { id } = match.params;
        dispatch(getShipnameList());

        if (this.props.isSpecial) {
            dispatch(getSpecialAccessUserDetails(id));
        } else {
            dispatch(getMMPLUsersDetails(id));
        }
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        const { dispatch, UserInformation, UserDetails, SpecialUserDetails, isSpecial } = nextProps;
        if (!isSpecial && UserDetails && UserDetails !== "") {
            prevState.UserInfo.userId = UserDetails.mmplId;
            prevState.UserInfo.emailId = UserDetails.mail;
            prevState.UserInfo.isAdmin = UserDetails.isAdmin;
            dispatch({ type: "UserDetails", data: "" });
        }
        if (!isSpecial && UserInformation && UserInformation !== "") {
            prevState.Users = UserInformation.ships;
            prevState.ships = UserInformation.ships;
            // .map(r => { return (r.shipName) });
            dispatch({ type: "getUserDetailsSuccess", data: "" });
        }
        if (
            isSpecial &&
            SpecialUserDetails &&
            SpecialUserDetails.ships &&
            nextProps.ShipNameList &&
            nextProps.ShipNameList.length > 0 &&
            prevState.UserInfo.userId !== SpecialUserDetails.specialAccessId
        ) {

            prevState.UserInfo.userId = SpecialUserDetails.specialAccessId;
            prevState.UserInfo.emailId = SpecialUserDetails.mail;
            prevState.UserInfo.isAdmin = false;

            const selectedShips = nextProps.ShipNameList.filter(ship =>
                SpecialUserDetails.ships.some(s => s.shipId === ship.shipID)
            );

            prevState.ships = selectedShips;
        }
        return null;
    }

    handleInputChange(e) {
        this.state.UserInfo.emailId = e.target.value;
        this.setState({});
    }

    handleCheckBoxChange(e) {
        if (e.target.checked) {
            this.state.UserInfo.isAdmin = true;
            this.setState({});
        } else {
            this.state.UserInfo.isAdmin = false;
            this.setState({});
        }
    }
    handleCheckBoxChange1(e) {
        if (e.target.checked) {
            this.state.UserInfo.isAdmin = false;
            this.setState({});
        } else {
            this.state.UserInfo.isAdmin = true;
            this.setState({});
        }
    }

    UpdateData() {
        const { dispatch, match } = this.props;
        const { params } = match;
        const { id } = params;
        const selectedShips =
            this.state.ships && this.state.ships.length > 0
                ? this.state.ships.map((item) => item.shipName).toString()
                : null;
        // let userinfo = {
        //     userId: parseInt(id),
        //     isAdmin: this.state.UserInfo.isAdmin,
        //     email: this.state.UserInfo.emailId,
        //     mmplShips: this.state.ships ? this.state.ships.map(item => item.shipName).toString() : "",
        //     isDeleted: false,
        //     modifiedBy: this.state.UserInfo.modifiedBy,
        // };

        let userinfo = {};

        if (this.props.isSpecial) {
            userinfo = {
                userId: parseInt(id),
                email: this.state.UserInfo.emailId,
                ships: selectedShips,
                modifiedBy: this.state.UserInfo.modifiedBy,
                isDeleted: false
            };
        } else {
            userinfo = {
                userId: parseInt(id),
                isAdmin: this.state.UserInfo.isAdmin,
                email: this.state.UserInfo.emailId,
                mmplShips: selectedShips,
                isDeleted: false,
                modifiedBy: this.state.UserInfo.modifiedBy,
            };
        }

        if (this.state.UserInfo.emailId !== "") {
            let emailregex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
            if (emailregex.test(this.state.UserInfo.emailId)) {
                let url = "";
                if (this.props.isSpecial) {
                    url = API.UpdateSpecialAccessUser;
                } else {
                    url = API.UpdateMmplUser;
                }
                axios.put(url, userinfo, {
                    headers: {
                        key: userkey.accessToken,
                    }
                })
                    .then((response) => {
                        if (response.data) {
                            toast.success("Updated Successfully", {
                                position: "top-right",
                                autoClose: 5000,
                                hideProgressBar: true,
                                closeOnClick: true,
                                pauseOnHover: true,
                                draggable: true,
                                progress: undefined,
                            });
                            this.hideSidePanel();
                        }
                        if (this.props.isSpecial) {
                            dispatch(getSpecialAccessUserDetails(id));
                        } else {
                            dispatch(getMMPLUsersList(searchData));
                        }
                        dispatch({
                            type: "UpdateUserSuccess",
                            data: response.data
                        })
                    })
                    .catch((error) => {
                        swal("Error!", "Something went wrong. Please try again.", "warning");
                        dispatch({
                            type: "UpdateUserFailure",
                            error: "ERROR"
                        })
                    })
            }
            else {
                swal("Error!", "Invalid email format", "warning");
            }
        }
        else {
            swal("Error!", "Email is mandatory", "warning");
        }
    }

    onSelectChange(selectedList) {

        console.log("hii1", this.state.ships)
        this.setState({ ships: selectedList });
    }

    onRemoveChange(selectedList) {
        this.setState({ ships: selectedList });
    }

    hideSidePanel = () => {
        if (this.props.isSpecial) {
            this.props.history.push(`/Home/Management/SpecialAccessUser`);
        } else {
            this.props.history.push(`/Home/Management/User`);
        }
    };

    BacktoPrevious() {
        this.props.history.goBack();
    }

    render() {
        const { ShipNameList } = this.props;
        return (
            <div className="full-height">
                <div className="pt-3">
                    <div className="row px-3 pb-3">
                        <button
                            className="btn btn-primary text-uppercase txtside-btn txtht-btn blue"
                            onClick={() => this.BacktoPrevious()}
                        >
                            <div style={{ position: 'relative' }}>
                                <span className="backarr">&larr;</span> <span style={{ marginLeft: "18px" }}>Back</span>
                            </div>
                        </button>
                    </div>
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="panel-box">
                                <div className="card MM-card-header mb-0" style={{ backgroundColor: "white", border: "0px" }}>
                                    <div className="card-body">
                                        <h5 className="card-title ml-4 mt-2" style={{ color: "092a51" }}>
                                            Update User
                                        </h5>
                                    </div>
                                </div>
                                <div className="search-filter-box">
                                    <div className="row">
                                        <div className="col-lg-4">
                                            <label className="form-label">Email<span className="mandatory">*</span></label>
                                            <br></br>
                                            <input
                                                className="form-control"
                                                type="text"
                                                name="emailId"
                                                placeholder="Email"
                                                value={this.state.UserInfo.emailId}
                                                onChange={e => this.handleInputChange(e)}
                                            // readOnly
                                            ></input>
                                        </div>
                                        {!this.props.isSpecial && (<div className="col-lg-2">
                                            <label className="form-label">Is Admin</label>
                                            <br></br>
                                            <div className="d-flex align-items-center">
                                                <input
                                                    style={{ height: '20px', width: '20px' }}
                                                    type="checkbox"
                                                    name="isAdmin"
                                                    id="adminyes"
                                                    className="mr-2"
                                                    checked={this.state.UserInfo.isAdmin}
                                                    onChange={(e) => this.handleCheckBoxChange(e)}
                                                ></input>
                                                <label htmlFor="adminyes" className="form-label mr-3">Yes</label>
                                                <input
                                                    style={{ height: '20px', width: '20px' }}
                                                    type="checkbox"
                                                    name="isAdminno"
                                                    id="adminno"
                                                    className="mr-2"
                                                    checked={!this.state.UserInfo.isAdmin}
                                                    onChange={(e) => this.handleCheckBoxChange1(e)}
                                                ></input>
                                                <label htmlFor="adminno" className="form-label">No</label>
                                            </div>
                                        </div>)}
                                        {!this.state.UserInfo.isAdmin ? (
                                            <div className="col-lg-6">
                                                <label className="form-label" >Ship Name</label><br></br>
                                                <Multiselect options={ShipNameList}
                                                    //  isObject={false}
                                                    displayValue="shipName"
                                                    style={{ option: { "margin-right": 0, "display": "block", "font-weight": "normal" }, chips: { "background-color": "#1a3464" } }}
                                                    onSelect={(selectedList) => this.onSelectChange(selectedList)}
                                                    onRemove={(selectedList) => this.onRemoveChange(selectedList)}
                                                    selectedValues={this.state.ships}
                                                    placeholder={this.state.ships && this.state.ships.length ? "" : "Select"}
                                                    closeIcon="cancel"
                                                />
                                            </div>
                                        ) : null}
                                    </div>
                                    <div className="row py-3">
                                        <div className="col-lg-12">
                                            <div className="search-btn-col" style={{ textAlign: "end" }}>
                                                <button
                                                    className="btn btn-primary text-uppercase txtside-btn txtht-btn blue"
                                                    type="submit"
                                                    onClick={() => this.UpdateData()}
                                                >
                                                    {" "}Update{" "}
                                                </button>
                                                <button
                                                    className="btn btn-light text-uppercase txtside-btn txtht-btn ml-3"
                                                    type="button"
                                                    onClick={() => this.hideSidePanel()}
                                                >
                                                    {" "}Cancel{" "}
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {/* <div className="row py-3">
                                    <div className="col-lg-12">
                                        <div className="search-btn-col" style={{ textAlign: "end" }}>
                                            <button
                                                className="btn btn-primary text-uppercase txtside-btn txtht-btn blue"
                                                type="submit"
                                                onClick={() => this.UpdateData()}
                                            >
                                                {" "}Update{" "}
                                            </button>
                                            <button
                                                className="btn btn-light text-uppercase txtside-btn txtht-btn ml-3"
                                                type="button"
                                                onClick={() => this.hideSidePanel()}
                                            >
                                                {" "}Cancel{" "}
                                            </button>
                                        </div>
                                    </div>
                                </div> */}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
function mapStateToProps(state) {
    return {
        UserDetails: state.UserManageReducer.UserDetails,
        ShipNameList: state.UserManageReducer.ShipNameList,
        UserInformation: state.UserManageReducer.UserInformation,
        UsersList: state.UserManageReducer.UsersList,
        SpecialUserDetails: state.SpecialAccessUserManageReducer.UserInformation
    };
}
function mapDispatchToProps(dispatch) {
    return {
        dispatch,
    };
}
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(EditUser);
